import CarHireMostPopularMaker from './CarHireMostPopularMaker';

export default CarHireMostPopularMaker;
